import * as APIHelper from "services/api"
import * as endPoint from "shared/constants/endpoint"

class DGItemProfileBusiness {
  getData = async searchParams => {
    const options = { params: searchParams }
    const response = (await APIHelper.getRequest(`${endPoint.dgItemProfile.search}`, options)) || {}
    return response?.resource || []
  }

  getDetailData = async id => {
    const response = await APIHelper.getRequest(`${endPoint.dgItemProfile.getDetail}?ID=${id}`)
    return Array.isArray(response?.resource) ? response?.resource[0] : null
  }

  addData = async data => {
    const response = await APIHelper.postRequest(`${endPoint.dgItemProfile.post}`, data)
    return response
  }

  updateData = async data => {
    const response = await APIHelper.patchRequest(`${endPoint.dgItemProfile.put}`, data)
    return response
  }

  deleteData = async params => {
    const response = await APIHelper.deleteRequest(`${endPoint.dgItemProfile.delete}`, params)
    return Array.isArray(response) ? response[0] : null
  }
}

export const dgItemProfileBusiness = new DGItemProfileBusiness()
